import React from "react";
import bannerImage from "./../../assets/banner.svg";
import bannerStartImage from "./../../assets/banner_start.svg";

import arrowDown from "./../../assets/Polygon.svg";
function Banner() {
  return (
    <div className="bg-[#96C83C] h-[166px] relative py-5 w-full minus-custom-z-index" id="header-banner">
      <img
        src={bannerStartImage}
        alt="image"
        className="absolute top-3 left-0 z-10 hidden sm:hidden lg:block w-auto object-cover"
      />
      <div className="w-full">
        <p className="text-white text-3xl z-20 relative text-center font-bold py-2">
          How will CheckinAsyst benefit my practice?
        </p>
        <p className="py-4 text-center relative z-20 font-medium text-black text-2xl">
          Calculate your Return on Investment by providing the below details:
        </p>
      </div>
      <img
        src={bannerImage}
        alt="image"
        className="absolute top-0 right-0 z-10 hidden sm:hidden lg:block w-auto object-cover"
      />
    </div>
  );
}

export default Banner;
